import React from 'react';
import PropTypes from 'prop-types';

// State
import { useSelector } from 'react-redux';
import { selectTaskByRecommendationId } from './store/slices/tasks';

// Components
import Details from './components/Modal/Details';

const TaskDetails = (props) => {
  const { recommendationId, onClick } = props;
  const content = useSelector(selectTaskByRecommendationId(recommendationId));

  if (!content) {
    return null;
  }

  return <Details content={content} onClick={onClick} />;
};

TaskDetails.propTypes = {
  onClick: PropTypes.func,
  recommendationId: PropTypes.string
};

export default TaskDetails;
